import { render, staticRenderFns } from "./MessageListMessageCompact.vue?vue&type=template&id=57399d08&scoped=true&functional=true&"
import script from "./MessageListMessageCompact.vue?vue&type=script&lang=js&"
export * from "./MessageListMessageCompact.vue?vue&type=script&lang=js&"
import style0 from "./MessageListMessageCompact.vue?vue&type=style&index=0&id=57399d08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "57399d08",
  null
  
)

export default component.exports